import { useState } from "react";

export const useGlobalData = () => {
  const [data] = useState({
    date: "June 6-9",
    year: "2027",
    shortYear: "27",
    hotel: "Omni La Costa Resort & Spa",
    location: "Carlsbad, CA",
  });

  return data;
};
